import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeContextProvider, useThemeMode } from './contexts/ThemeContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import AppLayout from './components/AppLayout';
import LogoutNotification from './components/LogoutNotification';
import SessionWarning from './components/SessionWarning';
import LoginAlternative from './pages/LoginAlternative';
import Portfolio from './pages/Portfolio';
import StockDetails from './pages/StockDetails';
import Research from './pages/Research';
import Orders from './pages/Orders';
import News from './pages/News';
import Watchlist from './pages/Watchlist';
import PnL from './pages/PnL';
import Home from './pages/Home';
import Help from './pages/Help';
import Assistant from './pages/Assistant';
import OptionsRecommendations from './pages/OptionsRecommendations';
import './App.css';

function AppContent() {
  const { user, loading } = useAuth();

  // Show nothing while auth state is being determined (prevents flash to login)
  if (loading) {
    return null;
  }

  return (
    <div className="App">
      <LogoutNotification />
      <SessionWarning />
      {user ? (
        <AppLayout>
          <Routes>
            <Route path="/home" element={<Home />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/research" element={<Research />} />
            <Route path="/search" element={<Navigate to="/research" />} />
            <Route path="/market" element={<Navigate to="/research" />} />
            <Route path="/trading" element={<Navigate to="/research" />} />
            <Route path="/stock/:symbol" element={<StockDetails />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/news" element={<News />} />
            <Route path="/watchlist" element={<Watchlist />} />
            <Route path="/pnl" element={<PnL />} />
            <Route path="/options" element={<OptionsRecommendations />} />
            <Route path="/options/:symbol" element={<OptionsRecommendations />} />
            <Route path="/help" element={<Help />} />
            <Route path="/assistant" element={<Assistant />} />
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/login" element={<Navigate to="/home" />} />
          </Routes>
        </AppLayout>
      ) : (
        <Routes>
          <Route path="/login" element={<LoginAlternative />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      )}
    </div>
  );
}

function ThemedApp() {
  const { theme } = useThemeMode();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <AppContent />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

function App() {
  return (
    <ThemeContextProvider>
      <ThemedApp />
    </ThemeContextProvider>
  );
}

export default App;
